import { EMPTY, indexOf } from './board.js';
/**
 * Опускает сегменты капсул, пока всё не встанет на опору. Вирусы неподвижны.
 *
 * Блок падения — одиночный сегмент, горизонтальная пара (падает, только если обе клетки под ней
 * свободны) или вертикальная пара (падает, если свободна клетка под нижней половиной).
 * Проход идёт снизу вверх и слева направо, за проход блок опускается не более чем на строку.
 * Проходы повторяются, пока что-то движется. Порядок фиксирован — результат детерминирован.
 */
export function applyGravity(board, 
/** Занятые клетки вне поля (падающая капсула): сегменты на них не опускаются. */
blocked = new Set()) {
    const cells = board.cells.slice();
    const at = (x, y) => cells[indexOf(board, x, y)] ?? EMPTY;
    const isFree = (x, y) => y < board.height && at(x, y).kind === 'empty' && !blocked.has(indexOf(board, x, y));
    let moves = 0;
    let movedInPass = true;
    while (movedInPass) {
        movedInPass = false;
        for (let y = board.height - 2; y >= 0; y--) {
            for (let x = 0; x < board.width; x++) {
                const cell = at(x, y);
                // Правую и верхнюю половины пары двигает её левая / нижняя половина.
                if (cell.kind !== 'segment' || cell.link === 'left' || cell.link === 'down') {
                    continue;
                }
                let unit;
                let canFall;
                if (cell.link === 'right') {
                    unit = [
                        [x, y],
                        [x + 1, y],
                    ];
                    canFall = isFree(x, y + 1) && isFree(x + 1, y + 1);
                }
                else if (cell.link === 'up') {
                    unit = [
                        [x, y - 1],
                        [x, y],
                    ];
                    canFall = isFree(x, y + 1);
                }
                else {
                    unit = [[x, y]];
                    canFall = isFree(x, y + 1);
                }
                if (!canFall) {
                    continue;
                }
                const moving = unit.map(([ux, uy]) => [ux, uy, at(ux, uy)]);
                for (const [ux, uy] of moving) {
                    cells[indexOf(board, ux, uy)] = EMPTY;
                }
                for (const [ux, uy, c] of moving) {
                    cells[indexOf(board, ux, uy + 1)] = c;
                }
                moves++;
                movedInPass = true;
            }
        }
    }
    return { board: { ...board, cells }, moves };
}
//# sourceMappingURL=gravity-resolver.js.map